import { render, staticRenderFns } from "./PostTemplatePreview.vue?vue&type=template&id=5e6c98ba&"
import script from "./PostTemplatePreview.vue?vue&type=script&lang=js&"
export * from "./PostTemplatePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports